<template>
  <a-form
    :layout="formLayout"
    :form="form"
    @submit="handleSubmit"
  >

    <a-form-item label="Масштаб от 0 до 1">
      <a-input-number
        v-decorator="[
          'zoom',
          {
            rules: [{ required: true, message: 'Впишите число' }],
          },
        ]"
        style="width: 150px"
      />
    </a-form-item>
     <a-form-item>
      <a-button type="primary" html-type="submit">
        Сохранить
      </a-button>
    </a-form-item>
  </a-form>
</template>
<script>
import bent from 'bent';
import moment from 'moment'

export default {
  props: [
    'initialData',
    'baseUrl',
    'zoomSettings',
    'panelId',
    'password',
    'adminpassword',
  ],
  components: {},
  data() {
    return {
      moment: moment,
      zoom: 1,
      formLayout: 'vertical',
      form: this.$form.createForm(this, { name: 'coordinated' }),
      post: {},
    };
  },
  async mounted() {
    this.post = bent(this.baseUrl, 'POST', 'json', 200);
    this.init();
  },
  computed: {},
  watch: {
    zoomSettings(value) {
      setTimeout(() => {
        this.form.setFieldsValue({
          zoom: value.zoom
        });
      }, 0);
    },
  },
  methods: {
    async init() {
      setTimeout(() => {
        this.form.setFieldsValue({
          zoom: this.zoomSettings.zoom
        });
        this.zoom = this.zoomSettings.zoom
      }, 0);
    },
    async saveZoomSettings(settings) {
      console.log({settings})
      try {
        await this.post('saveZoomSettings', {
          panelId: this.panelId,
          password: this.password,
          adminpassword: this.adminpassword,
          settings: settings
        });
      } catch (error) {
        console.log(error);
        alert('Ошибка сохранения');
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, settings) => {
        if (!err) {
          await this.saveZoomSettings({
            ...settings
          });
          this.$emit('zoomChange', settings);
        }
      });
    }
  },
};
</script>
<style scoped>

</style>
